import Vue from 'vue'
import App from './App.vue'
//引入路由
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { message } from './units/resetMessage.js'

Vue.use(ElementUI)

import axios from 'axios'
Vue.prototype.$http = axios
Vue.prototype.$message = message

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
// Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false
import moment from 'moment'
Vue.filter('datefmt', function(input, fmtstring) { //当input为时间戳，需转为Number类型
	if (input) {
		return moment(input).format(fmtstring);
	} else {
		return "";
	}
});

new Vue({
  render: h => h(App),
  // 注册路由
  router
}).$mount('#app')
